import { __ } from '@wordpress/i18n';

const validChecker = ( regex, message, required, messageDiv, fieldInput ) => {
	if ( regex.test( fieldInput.value ) ) {
		messageDiv.style.display = 'none';
		fieldInput.setCustomValidity('');
	} else if ( ! fieldInput.value ) {
		messageDiv.textContent = required;
		messageDiv.style.display = 'block';
		fieldInput.setCustomValidity(false);
	} else {
		messageDiv.textContent = message;
		messageDiv.style.display = message !== '' ? 'block' : 'none';
		fieldInput.setCustomValidity(false);
	}
};

export const inputValidation = ( field, messageField, type ) => {
	const fieldInput = document.querySelector( field );
	const messageDiv = document.querySelector( messageField );
	if ( ! fieldInput ) {
		return;
	}
	let regex = '';
	let message = '';
	const required = __( 'Pole obowiązkowe', 'knc' );

	switch ( type ) {
		case 'name':
			regex = /^[\p{L}\s]{3,}$/u;
			message = __( 'Wpisz poprawne imię.', 'knc' );
			break;
		case 'surname':
			regex = /^[^\d]{2,}$/;
			message = __( 'Wpisz poprawne nazwisko.', 'knc' );
			break;
		case 'phone':
			regex = /^\d{9}$/;
			message = __( 'Wpisz prawidłowy telefon.', 'knc' );
			break;
		case 'password':
			regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/;
			break;
		case 'email':
			regex = /^(?![+%_.-])[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
			message = __( 'Wpisz prawidłowy mail.', 'knc' );
			break;
		case 'zip-code':
			regex = /^([0-9]{2})(-[0-9]{3})$/;
			message = __( 'Wpisz prawidłowy kod pocztowy.', 'knc' );
			break;
	}

	const handler = () => validChecker( regex, message, required, messageDiv, fieldInput );

	fieldInput.addEventListener( 'input', handler );
	fieldInput.addEventListener( 'focus', handler );
	fieldInput.addEventListener( 'focusout', handler );
	fieldInput.addEventListener( 'blur', handler );

	handler();
};

const validatePassword = ( password ) => {
	const conditions = {
		hasDigit: /(?=.*\d)/,
		hasLowercase: /(?=.*[a-z])/,
		hasUppercase: /(?=.*[A-Z])/,
		hasSpecialChar: /(?=.*[!@#$%^&*])/,
		hasMinLength: /.{8,}/
	};

	return {
		hasDigit: conditions.hasDigit.test( password ),
		hasLowercase: conditions.hasLowercase.test( password ),
		hasUppercase: conditions.hasUppercase.test( password ),
		hasSpecialChar: conditions.hasSpecialChar.test( password ),
		hasMinLength: conditions.hasMinLength.test( password )
	};
};

export const passwordValidation = ( passwordField, messageFields = [] ) => {
	const messageDivs = document.querySelectorAll( messageFields );

	const handler = () => {
		const results = validatePassword( passwordField.value );

		const classConditions = {
			hasDigit: 'hasDigit',
			hasLetters: ( results ) => results.hasLowercase && results.hasUppercase,
			hasLowercase: 'hasLowercase',
			hasUppercase: 'hasUppercase',
			hasSpecialChar: 'hasSpecialChar',
			hasMinLength: 'hasMinLength'
		};

		const toggleClasses = ( div, condition ) => {
			const isValid = typeof condition === 'function' ? condition( results ) : results[condition];
			div.classList.add( isValid ? 'valid' : 'invalid' );
			div.classList.remove( isValid ? 'invalid' : 'valid' );
		};

		messageDivs.forEach( div => {
			div.classList.forEach( className => {
				if ( classConditions[className] ) {
					toggleClasses( div, classConditions[className] );
				}
			} );
		} );
	};

	handler();

};

export const sameValueChecker = ( firstInput, secondInput, messageField ) => {
	const firstValue = document.querySelector( firstInput );
	const secondValue = document.querySelector( secondInput );
	const message = document.querySelector( messageField );
	if ( ! firstValue || ! secondValue || ! message ) {
		return true;
	}
	const sameValue = () => {
		if ( firstValue.value !== secondValue.value ) {
			message.classList.add( 'd-block' );
			message.classList.remove( 'd-none' );
			return false;
		} else {
			message.classList.add( 'd-none' );
			message.classList.remove( 'd-block' );
			return true;
		}
	};

	firstValue && firstValue.addEventListener( 'keyup', sameValue );
	firstValue && firstValue.addEventListener( 'paste', sameValue );
	firstValue && firstValue.addEventListener( 'input', sameValue );

	secondValue && secondValue.addEventListener( 'keyup', sameValue );
	secondValue && secondValue.addEventListener( 'paste', sameValue );
	secondValue && secondValue.addEventListener( 'input', sameValue );

	return sameValue();
};

export const onlyNumbersInput = ( inputFields ) => {
	const fields = document.querySelectorAll( inputFields );

	if ( ! fields ) {
		return;
	}

	Array.from( fields ).forEach( field => {
		field && field.addEventListener( 'keypress', ( e ) => {
			e.target.value.replace( /[^0-9]/g, '' );
			if ( e.key < '0' || e.key > '9' ) {
				e.preventDefault();
			}
		} );
	} );
};

export const zipFieldNumbers = ( zipFields ) => {
	const fields = document.querySelectorAll( zipFields );

	if ( ! fields ) {
		return;
	}

	Array.from( fields ).forEach( field => {
		field && field.addEventListener( 'keypress', ( e ) => {
			if ( e.key < '0' || e.key > '9' ) {
				e.preventDefault();
			}
			let value = e.target.value.replace( /[^0-9]/g, '' );
			if ( value.length > 2 ) {
				value = value.slice( 0, 2 ) + '-' + value.slice( 2, 5 );
			}
			e.target.value = value;
			if ( e.target.selectionStart === 3 && value.length === 3 ) {
				e.target.setSelectionRange( 2, 2 );
			}
		} );
	} );
};

export const passwordChecker = () => {
	const passwordField = document.querySelector( 'input[name="password"]' );
	const passwordRepeat = document.querySelector( 'input[name="password-repeat"]' );
	const passwordMessage = document.querySelector( '.invalid-feedback.invalid-password-checker' );

	if ( ! passwordField || ! passwordRepeat ) {
		return;
	}

	const samePassword = () => {
		if ( passwordField.value !== passwordRepeat.value ) {
			passwordMessage.classList.add( 'd-block' );
			passwordMessage.classList.remove( 'd-none' );
		} else {
			passwordMessage.classList.add( 'd-none' );
			passwordMessage.classList.remove( 'd-block' );
		}
	};

	const passwordHandler = () => {
		samePassword();
		passwordValidation(
			passwordField,
			[
				'.hasMinLength',
				'.hasLetters',
				'.hasLowercase',
				'.hasUppercase',
				'.hasDigit',
				'.hasSpecialChar'
			] );
	};

	passwordField.addEventListener( 'keyup', passwordHandler );
	passwordField.addEventListener( 'paste', passwordHandler );
	passwordField.addEventListener( 'input', passwordHandler );

	passwordRepeat.addEventListener( 'keyup', samePassword );
	passwordRepeat.addEventListener( 'paste', samePassword );
	passwordRepeat.addEventListener( 'input', samePassword );
};
